module.exports = __webpack_public_path__ + "img/wximg31.726675a2.png";